export interface IPasswordService {
  postPassword(
    username: string,
    password: string,
    xsrfToken: string,
    traceparent: string,
  ): Promise<Response>;
  getSmsData(
    xsrfToken: string,
    traceparent: string,
    signal?: AbortSignal,
  ): Promise<Response>;
}

export class PasswordService implements IPasswordService {
  getSmsData(
    xsrfToken: string,
    traceparent: string,
    signal?: AbortSignal,
  ): Promise<Response> {
    return fetch('/sms/data', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': xsrfToken,
        'X-Requested-With': 'XMLHttpRequest',
        traceparent: traceparent,
      },
      signal,
    });
  }

  postPassword(
    username: string,
    password: string,
    xsrfToken: string,
    traceparent: string,
  ): Promise<Response> {
    return fetch('/ui/login/password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': xsrfToken,
        'X-Requested-With': 'XMLHttpRequest',
        traceparent,
      },
      body: JSON.stringify({
        username,
        password,
      }),
    });
  }
}
export const PasswordServiceToken = Symbol(PasswordService.name);
